const REGIONS_KEYS = {
  REGIONS: () => ['regions'],
  REGION: (uid) => ['regions', uid],
  REGIONS_SUPER_USER_PAGINATED: (params = {}) => ['regions', 'super-user', 'paginated', params],
  REGIONS_SUPER_USER_INFINITE: ({ search } = {}) => [
    'regions',
    'super-user',
    'infinite',
    { search },
  ],
  REGION_SUPER_USER: (uid) => ['regions', 'super-user', uid],
  REGION_AVAILABILITY: (name) => ['regions', 'availability', 'name', name],
  SUBDOMAIN_AVAILABILITY: (subdomain) => ['regions', 'availability', 'subdomain', subdomain],
  SUBSCRIPTION_PLANS: (region) => ['subscription_plans', { region }],
  HOW_TO_HUB_MODULES: (uid) => [REGIONS_KEYS.REGION(uid), 'how_to_hub_modules'],
  REGION_PAGE_MODULES: (uid) => [REGIONS_KEYS.REGION(uid), 'page_modules'],
  REGION_PAGE_AVAILABLE_BANNERS: (uid) => [REGIONS_KEYS.REGION(uid), 'page_available_banners'],
  REGION_PAGE_AVAILABLE_VIDEOS: (uid) => [REGIONS_KEYS.REGION(uid), 'page_available_videos'],
  REGION_PAGE_AVAILABLE_LOOKS: (uid) => [REGIONS_KEYS.REGION(uid), 'page_available_looks'],
  REGION_PAGE_AVAILABLE_FAVORITE_PRODUCTS: (uid) => [
    REGIONS_KEYS.REGION(uid),
    'page_available_favorite_products',
  ],
  REGION_PAGE_AVAILABLE_PARTICIPANTS: (uid) => [
    REGIONS_KEYS.REGION(uid),
    'page_available_participants',
  ],
  REGION_PAGE_AVAILABLE_LOCATIONS: (uid) => [REGIONS_KEYS.REGION(uid), 'page_available_locations'],
  REGION_PAGE_AVAILABLE_EVENTS: (uid) => [REGIONS_KEYS.REGION(uid), 'page_available_events'],
  REGION_BANNERS: (uid) => [REGIONS_KEYS.REGION(uid), 'banners'],
  REGION_VIDEOS: (uid) => [REGIONS_KEYS.REGION(uid), 'videos'],
  REGION_CONFIG: (uid) => ['regions', uid, 'config'],
  REGION_LIVE_FEED: (uid) => ['regions', uid, 'live_feed'],
  CHECKOUT_CONFIGURATION: (uid) => ['regions', 'checkout_configuration', uid],
};

export default REGIONS_KEYS;
